import { fetchPost, fetchGet, fetchDelete } from './fetch';
import { GenerateReimagineParams } from './interface';
import { AudioDto, GenerateAudioInputParamsV2 } from './type';

export type GeneratorResponseDTO = {
  data?: AudioDto[];
  creditBalance: number;
  error?: {
    errorMessage: string;
    errorCode: string;
    statusCode: number;
    timestamp: string;
  };
};

export type GenerateComposeTrackDTO = {
  data?: {
    prompt: string;
    // filePath: string;
  };
  error?: {
    errorMessage: string;
    code: number;
  };
};

export type SuperVoiceTrainDTO = {
  data?: {
    prompt: string;
  };
  error?: {
    errorMessage: string;
    code: number;
  };
};

const API_URL = '/api/v2/audio';

export const postAudioGenerateV2 = async (req: GenerateAudioInputParamsV2): Promise<GeneratorResponseDTO> => {
  const url = `${API_URL}/generate`;
  return fetchPost<GenerateAudioInputParamsV2, GeneratorResponseDTO>(url, req);
};

export const postAudioGenerateReimagine = async (req: GenerateReimagineParams): Promise<GeneratorResponseDTO> => {
  const url = `${API_URL}/reimagine`;
  return fetchPost<GenerateReimagineParams, GeneratorResponseDTO>(url, req);
};

export const postSuperTesterAudioGenerate = async (req: any): Promise<GeneratorResponseDTO> => {
  const url = `/api/v1/admin/generate_track`;
  return fetchPost<any, GeneratorResponseDTO>(url, req);
};

export const postSuperTesterAudioComposeGenerate = async (req: FormData): Promise<GenerateComposeTrackDTO> => {
  const url = `/api/v1/admin/generate_compose_track`;
  return fetchPost<FormData, GenerateComposeTrackDTO>(url, req);
};

export const postSuperVoiceTrain = async (req: FormData): Promise<SuperVoiceTrainDTO> => {
  const url = `/api/v1/super_voice/train`;
  return fetchPost<FormData, SuperVoiceTrainDTO>(url, req);
};

interface SuperVoiceListDTO {
  data: SuperVoiceItemDTO[];
}
export interface SuperVoiceItemDTO {
  id: number;
  status: 'uploading' | 'success' | 'failed';
  name: string;
  url: string;
  created_at: string;
}

export const getSuperVoiceList = async (): Promise<SuperVoiceListDTO> => {
  const url = `/api/v1/super_voice/list`;
  return fetchGet<SuperVoiceListDTO>(url);
};

export const deleteSuperVoice = async (id: number): Promise<void> => {
  const url = `/api/v1/super_voice/${id}`;
  return fetchDelete(url);
};

export const generateFromSuperVoice = async (req: FormData, id: number): Promise<void> => {
  const url = `/api/v1/super_voice/inference/${id}`;
  return fetchPost<FormData, any>(url, req);
};

export const getAudioDetail = async (req: { id: string }): Promise<any> => {
  const url = `/api/v1/admin/audio_detail/:id`;
  return fetchGet<any>(url, req, undefined);
};
